module.exports = __webpack_public_path__ + "h5/img/summer-nav3-1.84c4a1b0.png";